import { Identifier, RaRecord } from 'react-admin';

const tableRowSxWithNodeStatusVerification =
    (selectedRowsIds: Identifier[], multiSelectionState: boolean, action: any, statusId: string) =>
    (record: RaRecord) => ({
        ...(selectedRowsIds.includes(record?.id) && {
            bgcolor: (theme: any) => theme.palette.action.selected,
        }),
        ...(multiSelectionState &&
            action === 'create_quote' &&
            record?.currentNode?.configuration?.idForNodeHumanReadable !== statusId && {
                cursor: 'default !important',
            }),
    });

export default tableRowSxWithNodeStatusVerification;
